module.exports = __webpack_public_path__ + "static/media/iconCommunication.0174f6d7.svg";